  function ws_wishlist() {
    const wishlistButtons = document.querySelectorAll('.wishlist_button');
  const usermenubox = document.querySelector('.user-menu-box__header-heart-icon');
  const wishlistBlock = document.querySelector('.js-wishlistBlock');
  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

  function updateHeartIcon(productTitle) {
    const wishlistButton = document.querySelector(`.wishlist_button[data-product-title="${productTitle}"]`);
    if (!wishlistButton) return;
    
    const isAlreadyInWishlist = wishlistData.some(item => item.productTitle === productTitle);
    wishlistButton.innerHTML = isAlreadyInWishlist ? 
      `<svg class="heart-filled" viewBox="0 0 24 24" width="16" height="16" fill="#000" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.498 12.053L12.125 21l8.627-8.947a5.405 5.405 0 0 0 1.498-3.75C22.25 5.374 19.96 3 17.136 3a5.023 5.023 0 0 0-3.616 1.553L12.125 6 10.73 4.553A5.023 5.023 0 0 0 7.114 3C4.29 3 2 5.374 2 8.303c0 1.407.539 2.756 1.498 3.75z" stroke="#1C1C1C" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>` 
      : 
      `<svg class="heart-outline" viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.498 12.053L12.125 21l8.627-8.947a5.405 5.405 0 0 0 1.498-3.75C22.25 5.374 19.96 3 17.136 3a5.023 5.023 0 0 0-3.616 1.553L12.125 6 10.73 4.553A5.023 5.023 0 0 0 7.114 3C4.29 3 2 5.374 2 8.303c0 1.407.539 2.756 1.498 3.75z" stroke="#1C1C1C" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>`;

    if (usermenubox) {
      usermenubox.innerHTML = wishlistData.length > 0 ? `<span class="user-menu-box__header-heart-icon-inner"></span>` : `<span></span>`;
    }
  }

  function toggleWishlist(event) {
    const wishlistButton = event.currentTarget;
    const productTitle = wishlistButton.getAttribute('data-product-title');
    const productImage = wishlistButton.getAttribute('data-img');
    const productPr = wishlistButton.getAttribute('data-price');
    const productCompare = wishlistButton.getAttribute('data-compare');
    const productURL = wishlistButton.getAttribute('data-url');

    const pdpData = {
      productTitle: productTitle,
      productImg: productImage,
      productPrice: productPr,
      productComp: productCompare,
      productUrl: productURL
    };

    const isAlreadyInWishlist = wishlistData.some(item => item.productTitle === productTitle);
    if (!isAlreadyInWishlist) {
      wishlistData.push(pdpData);
      wishlistButton.classList.add("active");
    } else {
      wishlistData = wishlistData.filter(item => item.productTitle !== productTitle);
      wishlistButton.classList.remove("active");
    }
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));
    updateHeartIcon(productTitle);
    displayWishlist();
  }

  function displayWishlist() {
    wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
    if (wishlistData.length === 0) {
      console.log('Wishlist is empty');
      if (wishlistBlock) {
        wishlistBlock.innerHTML = ''; 
      } else {
        // Fallback: update wishlist button if exists
        var fallbackBtn = document.querySelector('.product-info__liquid .wishlist_button');
        if (fallbackBtn) {
          fallbackBtn.classList.add("active");
        }
      }
      return;
    }

    const wishlistHtml = wishlistData.map(item => `
      <div class="grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate" data-aos="row-of-4" data-product-handle="${item.productHandle}" data-product-id="${item.productId}">
        <div class="grid-product__content">
          <div class="grid__item-image-wrapper">
            <div class="grid-product__image-mask">
              <div class="image-wrap loaded" style="height: 0; padding-bottom: 133.33333333333334%;">
                <image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">
                  <img src="${item.productImg}" alt="${item.productTitle}" srcset="${item.productImg} 360w, ${item.productImg} 540w, ${item.productImg} 720w, ${item.productImg} 900w, ${item.productImg} 1080w" width="1080" height="1440.0" loading="lazy" class="grid-product__image image-style--image-element" sizes="(min-width: 769px) 25vw, 50vw">
                </image-element>
              </div>
            </div>
            <div class="grid-product__title grid-product__title--body">
              <div class="ws_grid-title">${item.productTitle}</div>
              <button class="wishlist_button_remove" data-product-title="${item.productTitle}" data-img="${item.productImg}" data-price="${item.productPrice}" data-compare="${item.productComp}" data-url="${item.productUrl}">
                <svg class="heart-filled" viewBox="0 0 24 24" width="16" height="16" fill="#000" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.498 12.053L12.125 21l8.627-8.947a5.405 5.405 0 0 0 1.498-3.75C22.25 5.374 19.96 3 17.136 3a5.023 5.023 0 0 0-3.616 1.553L12.125 6 10.73 4.553A5.023 5.023 0 0 0 7.114 3C4.29 3 2 5.374 2 8.303c0 1.407.539 2.756 1.498 3.75Z" stroke="#1C1C1C" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
            </div>
            <a href="${item.productUrl}" class="grid-product__link" style="position: unset;">
              <div class="grid-product__meta">
                <div class="grid-product__price">
                  ${item.productComp && item.productComp !== '0,00' ? `<span class="grid-product__price--original">${item.productComp}</span>` : ''}
                  <span class="grid-product__meta">${item.productPrice}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    `).join('');

    if (wishlistBlock) {
      wishlistBlock.innerHTML = wishlistHtml;
      const wishlistButtonsInBlock = wishlistBlock.querySelectorAll('.wishlist_button_remove');
      wishlistButtonsInBlock.forEach(button => {
        button.addEventListener('click', removeFromWishlist);
      });
    } else {
      // console.error('Element with class "js-wishlistBlock" not found');
      var fallbackBtn = document.querySelector('.product-info__liquid .wishlist_button');
      if (fallbackBtn) {
        fallbackBtn.classList.add("active");
      }
    }
  }

  function removeFromWishlist(event) {
    const wishlistButton = event.currentTarget;
    const productTitle = wishlistButton.getAttribute('data-product-title');
    wishlistData = wishlistData.filter(item => item.productTitle !== productTitle);
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));
    updateHeartIcon(productTitle);
    displayWishlist();
    if (usermenubox) {
      usermenubox.innerHTML = wishlistData.length > 0 ? `<span class="user-menu-box__header-heart-icon-inner"></span>` : `<span></span>`;
    }
  }

  wishlistButtons.forEach(button => {
    const productTitle = button.getAttribute('data-product-title');
    updateHeartIcon(productTitle);
    button.addEventListener('click', toggleWishlist);
  });

  displayWishlist();

  if (usermenubox) {
    usermenubox.innerHTML = wishlistData.length > 0 ? `<span class="user-menu-box__header-heart-icon-inner"></span>` : `<span></span>`;
  }
    
  }
document.addEventListener('DOMContentLoaded',  () =>  ws_wishlist());
